import React from "react"

import PartnerSponsorHeadline from "./partner-sponsor"
import SubcategoryHeadline from "./subcategory"
import { Wrapper, Title } from "./styles"

const Headline = ({
  title,
  partner,
  sponsor,
  subcategory,
  reviewer,
  personalStory,
  partnerImages,
  sponsorImages,
  imagesGatsby,
}) => (
  <Wrapper>
    {partner || sponsor ? (
      <PartnerSponsorHeadline
        partner={partner}
        sponsor={sponsor}
        partnerImages={partnerImages}
        sponsorImages={sponsorImages}
        imagesGatsby={imagesGatsby}
      />
    ) : (
      <SubcategoryHeadline
        subcategory={subcategory}
        reviewer={reviewer}
        personalStory={personalStory}
      />
    )}
    <Title dangerouslySetInnerHTML={{ __html: title }} />
  </Wrapper>
)

export default Headline
